{
  "en": {
    "loggingIn": "Logging in...",
    "uploading": "Uploading...",
    "linkExpiredTitle": "The link has expired",
    "linkExpiredText": "To get a new link tell ElliQ:\n\"ElliQ, let's add a photo\"",
    "supportCall": "For support call: (855) 888-1295",
    "homeTitle": "Send your photos to ElliQ",
    "homeSubtitle": "Add photos that you'd like to see on ElliQ's screen",
    "addPhotos": "Add photos",
    "addMorePhotos": "Add more photos",
    "ok": "Ok",
    "errorTitle": "Error",
    "tooLargeBody": "We can't allow pictures bigger than 10 MB. Please upload a smaller picture.",
    "readyToSend": "Ready to send?",
    "sendToElliq": "Send to ElliQ",
    "deletePhotoTitle": "Delete photo?",
    "deletePhotoText": "This won't affect the photos in your gallery",
    "delete": "Delete",
    "cancel": "Cancel",
    "maxImages": "You can't send ElliQ more than 10 pictures at once.",
    "sentSuccess": "Your photos have been sent to ElliQ!",
    "sentFail": "Your photos have not been sent to ElliQ!",
    "tryAgain": "Try again",
    "browserNotSupported": "Browser not supported for image processing. Please try a different browser or device.",
    "cropperTitle": "Move and scale photo",
    "save": "Save",
    "cropping": "Cropping image...",
    "cropSuccess": "Image cropped successfully!",
    "cropFailed": "Failed to crop image:"
  },
  "he": {
    "loggingIn": "מתחבר...",
    "uploading": "מעלה...",
    "linkExpiredTitle": "הקישור פג תוקף",
    "linkExpiredText": "כדי לקבל קישור חדש, אמרו ל-ElliQ:\n\"ElliQ, בואי נוסיף תמונה\"",
    "supportCall": "לתמיכה חייגו: (855) 888-1295",
    "homeTitle": "שלחו את התמונות שלכם ל-ElliQ",
    "homeSubtitle": "הוסיפו תמונות שתרצו לראות על המסך של ElliQ",
    "addPhotos": "הוספת תמונות",
    "addMorePhotos": "הוספת עוד תמונות",
    "ok": "אישור",
    "errorTitle": "שגיאה",
    "tooLargeBody": "לא ניתן להעלות תמונות גדולות מ-10 MB. אנא העלו תמונה קטנה יותר.",
    "readyToSend": "מוכנים לשלוח?",
    "sendToElliq": "שליחה ל-ElliQ",
    "deletePhotoTitle": "למחוק את התמונה?",
    "deletePhotoText": "זה לא ישפיע על התמונות בגלריה שלכם",
    "delete": "מחיקה",
    "cancel": "ביטול",
    "maxImages": "לא ניתן לשלוח ל-ElliQ יותר מ-10 תמונות בבת אחת.",
    "sentSuccess": "התמונות שלכם נשלחו ל-ElliQ!",
    "sentFail": "התמונות שלכם לא נשלחו ל-ElliQ!",
    "tryAgain": "נסו שוב",
    "browserNotSupported": "הדפדפן אינו נתמך לעיבוד תמונות. אנא נסו דפדפן או מכשיר אחר.",
    "cropperTitle": "הזיזו והגדילו את התמונה",
    "save": "שמירה",
    "cropping": "חותך תמונה...",
    "cropSuccess": "התמונה נחתכה בהצלחה!",
    "cropFailed": "חיתוך התמונה נכשל:"
  },
  "ja": {
    "loggingIn": "ログイン中...",
    "uploading": "アップロード中...",
    "linkExpiredTitle": "リンクの有効期限が切れました",
    "linkExpiredText": "新しいリンクを受け取るには、ElliQにこう言ってください：\n「ElliQ、写真を追加しよう」",
    "supportCall": "サポートへのお電話：(855) 888-1295",
    "homeTitle": "写真をElliQに送りましょう",
    "homeSubtitle": "ElliQの画面に表示したい写真を追加してください",
    "addPhotos": "写真を追加",
    "addMorePhotos": "写真をもっと追加",
    "ok": "OK",
    "errorTitle": "エラー",
    "tooLargeBody": "10MBを超える画像はアップロードできません。より小さい画像をアップロードしてください。",
    "readyToSend": "送信する準備はできましたか？",
    "sendToElliq": "ElliQに送信",
    "deletePhotoTitle": "写真を削除しますか？",
    "deletePhotoText": "ギャラリー内の写真には影響しません",
    "delete": "削除",
    "cancel": "キャンセル",
    "maxImages": "一度にElliQへ送れる写真は10枚までです。",
    "sentSuccess": "写真がElliQに送信されました！",
    "sentFail": "写真をElliQに送信できませんでした！",
    "tryAgain": "もう一度お試しください",
    "browserNotSupported": "このブラウザは画像処理に対応していません。別のブラウザまたはデバイスをお試しください。",
    "cropperTitle": "写真を移動・拡大縮小",
    "save": "保存",
    "cropping": "画像を切り抜いています...",
    "cropSuccess": "画像を切り抜きました！",
    "cropFailed": "画像の切り抜きに失敗しました:"
  }
}
